import { api } from './api'

export interface Recommendation {
  sessionId: number
  title: string
  subtitle: string
  startDate: string
  endDate: string
  description: string
  roomName: string
  credits: string
  eventTypeId: number
  score: number
  category: string
}

export interface RecommendationsResponse {
  email: string
  database: string
  limit: number
  recommendations: Recommendation[]
  totalCount: number
}

// Tenant is injected by the apiClient interceptor into /session/* paths
class RecommendationsService {
  async toggleRecommendations(enabled: boolean): Promise<void> {
    await api.post('/session/user/recommendations', { enabled })
  }

  async getRecommendations(email: string, limit: number = 10): Promise<RecommendationsResponse> {
    const encodedEmail = encodeURIComponent(email)
    return api.get<RecommendationsResponse>(`/session/recommendations/${encodedEmail}`, {
      params: { limit },
    })
  }
}

export const recommendationsService = new RecommendationsService()
